// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.markdown-editor {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
}

.markdown-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  gap: 8px;
}

.markdown-toolbar__buttons {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.markdown-toolbar__button {
  background: transparent;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #4a5568;
  transition: all 0.15s;
  min-width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.markdown-toolbar__button:hover {
  background: #edf2f7;
}

.markdown-toolbar__button.active {
  background: #3182ce;
  color: white;
}

.markdown-toolbar__switch-link,
.markdown-editor__switch-link {
  background: none;
  border: none;
  color: #3182ce;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  white-space: nowrap;
}

.markdown-toolbar__switch-link:hover,
.markdown-editor__switch-link:hover {
  text-decoration: underline;
}

.markdown-editor__mode-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
}

.markdown-editor__mode-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #4a5568;
  font-weight: 500;
}

.markdown-editor__info-icon {
  color: #a0aec0;
  cursor: help;
  font-size: 12px;
}

.markdown-editor__content {
  padding: 16px;
  min-height: 120px;
  outline: none;
  font-size: 14px;
  line-height: 1.6;
  background: #fff;
}

.markdown-editor__content p {
  margin: 0 0 1em 0;
}

.markdown-editor__content p:last-child {
  margin-bottom: 0;
}

.markdown-editor__content h1,
.markdown-editor__content h2,
.markdown-editor__content h3 {
  margin: 1em 0 0.5em 0;
  font-weight: 600;
}

.markdown-editor__content h1:first-child,
.markdown-editor__content h2:first-child,
.markdown-editor__content h3:first-child {
  margin-top: 0;
}

.markdown-editor__content h2 {
  font-size: 1.5em;
}

.markdown-editor__content ul,
.markdown-editor__content ol {
  padding-left: 1.5em;
  margin: 0.5em 0;
}

.markdown-editor__content code {
  background: #f7fafc;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: monospace;
  font-size: 0.9em;
}

.markdown-editor__content a {
  color: #3182ce;
  text-decoration: underline;
}

.markdown-editor__content blockquote {
  border-left: 3px solid #e2e8f0;
  padding-left: 1em;
  margin: 1em 0;
  color: #718096;
}

.markdown-editor__textarea {
  width: 100%;
  min-height: 120px;
  padding: 16px;
  border: none;
  outline: none;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
  background: #fff;
}

.markdown-editor__content p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  color: #a0aec0;
  pointer-events: none;
  height: 0;
  float: left;
}

.markdown-editor__footer {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f8fafc;
}

.markdown-editor__aa-toggle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #e2e8f0;
  color: #3182ce;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.markdown-editor__aa-toggle:hover {
  background: #cbd5e0;
}

.markdown-editor__aa-toggle.active {
  background: #3182ce;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/MarkdownEditor/MarkdownEditor.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".markdown-editor {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #f8fafc;\n}\n\n.markdown-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n  gap: 8px;\n}\n\n.markdown-toolbar__buttons {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.markdown-toolbar__button {\n  background: transparent;\n  border: none;\n  padding: 6px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #4a5568;\n  transition: all 0.15s;\n  min-width: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.markdown-toolbar__button:hover {\n  background: #edf2f7;\n}\n\n.markdown-toolbar__button.active {\n  background: #3182ce;\n  color: white;\n}\n\n.markdown-toolbar__switch-link,\n.markdown-editor__switch-link {\n  background: none;\n  border: none;\n  color: #3182ce;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 8px;\n  white-space: nowrap;\n}\n\n.markdown-toolbar__switch-link:hover,\n.markdown-editor__switch-link:hover {\n  text-decoration: underline;\n}\n\n.markdown-editor__mode-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background: #fff;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.markdown-editor__mode-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: #4a5568;\n  font-weight: 500;\n}\n\n.markdown-editor__info-icon {\n  color: #a0aec0;\n  cursor: help;\n  font-size: 12px;\n}\n\n.markdown-editor__content {\n  padding: 16px;\n  min-height: 120px;\n  outline: none;\n  font-size: 14px;\n  line-height: 1.6;\n  background: #fff;\n}\n\n.markdown-editor__content p {\n  margin: 0 0 1em 0;\n}\n\n.markdown-editor__content p:last-child {\n  margin-bottom: 0;\n}\n\n.markdown-editor__content h1,\n.markdown-editor__content h2,\n.markdown-editor__content h3 {\n  margin: 1em 0 0.5em 0;\n  font-weight: 600;\n}\n\n.markdown-editor__content h1:first-child,\n.markdown-editor__content h2:first-child,\n.markdown-editor__content h3:first-child {\n  margin-top: 0;\n}\n\n.markdown-editor__content h2 {\n  font-size: 1.5em;\n}\n\n.markdown-editor__content ul,\n.markdown-editor__content ol {\n  padding-left: 1.5em;\n  margin: 0.5em 0;\n}\n\n.markdown-editor__content code {\n  background: #f7fafc;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-family: monospace;\n  font-size: 0.9em;\n}\n\n.markdown-editor__content a {\n  color: #3182ce;\n  text-decoration: underline;\n}\n\n.markdown-editor__content blockquote {\n  border-left: 3px solid #e2e8f0;\n  padding-left: 1em;\n  margin: 1em 0;\n  color: #718096;\n}\n\n.markdown-editor__textarea {\n  width: 100%;\n  min-height: 120px;\n  padding: 16px;\n  border: none;\n  outline: none;\n  font-family: monospace;\n  font-size: 14px;\n  line-height: 1.6;\n  resize: vertical;\n  background: #fff;\n}\n\n.markdown-editor__content p.is-editor-empty:first-child::before {\n  content: attr(data-placeholder);\n  color: #a0aec0;\n  pointer-events: none;\n  height: 0;\n  float: left;\n}\n\n.markdown-editor__footer {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f8fafc;\n}\n\n.markdown-editor__aa-toggle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: #e2e8f0;\n  color: #3182ce;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.markdown-editor__aa-toggle:hover {\n  background: #cbd5e0;\n}\n\n.markdown-editor__aa-toggle.active {\n  background: #3182ce;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
